import {SET_CART_STATE, SET_CART_DATA, DELETE_CART_ITEM, SET_CART_ITEM_DATA, RESET_CART_DATA} from '../costants/ActionTypes'

const initialState = {
  status: "NOT_LOADED",
  subtotal: "0.0",
  total: "0.0",
  total_quantity: 6,
  num_items: 0,
  extra_rows: [],
  items: [

  ]
}


const ncart = (state = initialState, action) => {

    switch (action.type) {

      case SET_CART_STATE:
          return Object.assign({}, state, {
              status: action.status
          })

      case DELETE_CART_ITEM:

          const new_items = state.items.filter((element) => {return element.id !== action.item_id})

          return Object.assign({}, state, {
            items: [...new_items]
          })

      case RESET_CART_DATA:
          return Object.assign({}, state, action.data)

      case SET_CART_DATA:

          let new_state = Object.assign({}, state, {
              subtotal: action.data.subtotal,
              total: action.data.total,
              total_quantity: action.data.total_quantity,
              num_items: action.data.num_items
          })

          if (action.data.items){
              new_state.items = [...action.data.items]
          }
          if (action.data.extra_rows){
              new_state.extra_rows = [...action.data.extra_rows]
          }

          return new_state

      case SET_CART_ITEM_DATA:

          const copy_items = state.items.map((element, index) => {
              if (element.id === action.data.id) {
                  return action.data
              }
              return element
          });

          return Object.assign({}, state, {
            items: [...copy_items]
          })

      default:
        return state

  }
}

export default ncart